import styles from './About.module.css';
import ContentBox from '../../components/ContentBox/ContentBox.jsx';
import About1 from '../../assets/about1.jpg';
import About2 from '../../assets/about2.jpg';
import About3 from '../../assets/about3.jpg';
export default function About() {
    return (
        <main className={styles.about}>
<ContentBox 
    title="Wykształecenie"
    text="Nazywam się Joanna Sęk. Z wykształcenia jestem pedagogiem, logopedą, neurologopedą,
oligofrenopedagogiem oraz doradcą zawodowym. Stale rozwijam swoje umiejętności i
podnoszę swoje kwalifikacje – uczestniczę w szkoleniach, konferencjach i współpracuję z
innymi specjalistami (fizjoterapeutą, osteopatą, ortodontą, stomatologiem, laryngologiem).
Dzięki temu mogę zapewnić kompleksową i skuteczną pomoc."
    image={About1}
    contentWidth="40%" // Controls text area width
    leftSide={true} // Image on left, text on right
/>

<ContentBox 
    title="Moja misja"
    text="Od 20 lat pracuję z dziećmi i młodzieżą ze specjalnymi potrzebami edukacyjnymi oraz z
osobami z niepełnosprawnością, kierując się indywidualnym podejściem, empatią i
zrozumieniem. Każdy pacjent jest wyjątkowy, dlatego dopasowuję metody terapii do jego
potrzeb i możliwości. Cierpliwość, determinacja i kreatywność sprawiają, że terapia staje się
nie tylko skuteczna, ale też przyjazna i motywująca."
    image={About2}
    contentWidth="40%" // Fixed width in pixels
    leftSide={false} // Image on right, text on left
/>

<ContentBox 
    title="Dlaczego warto ze mną pracować?"
    text="Cierpliwość, empatia i kreatywność w prowadzeniu zajęć. 20-letnie doświadczenie w pracy z dziećmi i młodzieżą.
Przyjazna atmosfera sprzyjająca nauce i rozwojowi.
Wsparcie nie tylko dla pacjenta, ale także dla jego rodziny, aby terapia była skuteczna
również w codziennym życiu.
Elastyczne godziny pracy dostosowane do potrzeb i możliwości klientów."
    image={About3}
    contentWidth="40%" // Controls text area width
    leftSide={true} // Image on left, text on right
/>

        </main>
    );
}

